<div class="card">
  <h5 class="card-header d-flex justify-content-between align-items-center">
    <span><i class="fas fa-file-invoice me-2"></i>Master Accounts — Invoice Download</span>
    <span class="badge bg-primary" *ngIf="!isLoadingAccounts">
      <i class="fas fa-building me-1"></i>{{ masterAccounts.length }} accounts
    </span>
    <span class="badge bg-secondary" *ngIf="isLoadingAccounts">
      <i class="fas fa-spinner fa-spin me-1"></i>Loading...
    </span>
  </h5>

  <div class="card-body">

    <!-- Consolidated Report Bar -->
    <div class="inv-cons-bar mb-3">
      <div class="mb-2">
        <div class="inv-cons-title">
          <i class="fas fa-chart-bar me-2"></i>Consolidated Report
        </div>
        <div class="inv-cons-sub">
          Download invoices for all master accounts for a selected month and year
        </div>
      </div>
      <div class="inv-cons-form">
        <div class="inv-cons-field">
          <label class="inv-label">Month / Year</label>
          <input
            type="text"
            id="consolidatedMonthDate"
            class="form-control inv-select"
            [(ngModel)]="dateRange"
            readonly
            placeholder="MM/YYYY" />
        </div>
        <button
          type="button"
          class="btn btn-primary btn-sm inv-cons-btn"
          (click)="downloadConsolidatedReport()"
          [disabled]="isDownloadingConsolidated || isLoadingAccounts">
          <i class="fas fa-download me-1" *ngIf="!isDownloadingConsolidated"></i>
          <i class="fas fa-spinner fa-spin me-1" *ngIf="isDownloadingConsolidated"></i>
          {{ isDownloadingConsolidated ? 'Downloading...' : 'Download All' }}
        </button>
      </div>
    </div>

    <!-- Info Banner -->
    <div class="alert alert-info py-2 px-3 mb-3" style="font-size:0.85rem;">
      <i class="fas fa-info-circle me-1"></i>
      Select month and year for each account to download individual invoices as ZIP files via pre-signed URLs.
    </div>

    <!-- Loading State -->
    <div *ngIf="isLoadingAccounts" class="text-center py-4">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
      <p class="text-muted mt-2 mb-0">Loading master accounts...</p>
    </div>

    <!-- Search + Table -->
    <div *ngIf="!isLoadingAccounts">

      <!-- Search Bar -->
      <div class="d-flex justify-content-between align-items-center mb-2">
        <div class="input-group" style="max-width: 300px;">
          <span class="input-group-text bg-white">
            <i class="fas fa-search text-muted"></i>
          </span>
          <input
            type="text"
            class="form-control border-start-0"
            placeholder="Search account ID..."
            [(ngModel)]="searchQuery"
            (ngModelChange)="onSearch()" />
          <button
            *ngIf="searchQuery"
            class="btn btn-outline-secondary"
            type="button"
            (click)="clearSearch()">
            <i class="fas fa-times"></i>
          </button>
        </div>
        <span class="text-muted" style="font-size: 0.85rem;">
          Showing {{ filteredAccounts.length }} of {{ masterAccounts.length }} accounts
        </span>
      </div>

      <!-- Accounts Table -->
      <div class="inv-table-wrap">
        <table class="table table-docs table-hover table-sticky mb-0">
          <thead>
            <tr>
              <th>S.N.</th>
              <th>Account ID</th>
              <th class="inv-col-month">Month / Year</th>
              <th class="inv-col-action">Action</th>
              <th class="inv-col-status">Status</th>
            </tr>
          </thead>

          <tbody *ngIf="filteredAccounts.length > 0">
            <tr *ngFor="let account of filteredAccounts; let i = index">
              <td>{{ i + 1 }}</td>
              <td class="inv-account-id">{{ account.accId }}</td>
              <td>
                <input
                  type="text"
                  [id]="'rowDate_' + i"
                  class="form-control inv-select inv-select-sm"
                  [value]="account.month + '/' + account.year"
                  readonly
                  placeholder="MM/YYYY" />
              </td>
              <td>
                <button
                  class="btn btn-primary btn-sm"
                  (click)="downloadSingleInvoice(account)"
                  [disabled]="account.status === 'loading'">
                  <i class="fas fa-download me-1" *ngIf="account.status !== 'loading'"></i>
                  <i class="fas fa-spinner fa-spin me-1" *ngIf="account.status === 'loading'"></i>
                  {{ account.status === 'loading' ? 'Downloading...' : 'Download' }}
                </button>
              </td>
              <td>
                <span
                  *ngIf="account.statusMessage"
                  class="badge"
                  [ngClass]="'bg-' + getStatusBadgeClass(account.status)">
                  {{ account.statusMessage }}
                </span>
                <span *ngIf="!account.statusMessage" class="text-muted">—</span>
              </td>
            </tr>
          </tbody>

          <tbody *ngIf="filteredAccounts.length === 0">
            <tr>
              <td colspan="5" class="text-center py-4 text-muted">
                <i class="fas fa-search fa-2x d-block mb-2"></i>
                No accounts found for "<strong>{{ searchQuery }}</strong>"
              </td>
            </tr>
          </tbody>
        </table>
      </div>

    </div>

    <!-- Footer -->
    <p class="text-muted mt-3 mb-0" style="font-size:0.8rem;">
      <i class="fas fa-lightbulb me-1"></i>
      Use the consolidated report button to download all accounts at once, or select individual month/year per account.
    </p>

  </div>
</div>